import { Box, Container, Grid, Paper } from "@mui/material";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import { CardState, Data } from "../../../store/card/types";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";
import { isNil } from "ramda";
import { ApplicationState } from "../../../store";
import { fetchRequest as fetchCard } from "../../../store/card/actions";
import ItemsDetailViewSection, {
  ItemsDetail,
} from "../../../common/item/ItemsDetailViewSection";

const CardView = () => {
  const classes = pageStyles();
  const session = useSession();
  const dispatch = useDispatch();

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    !isNil(id) && dispatch(fetchCard(id));
  }, []);

  const getById = (cardState: CardState, id: string | undefined) => {
    return (
      id &&
      cardState &&
      cardState.data &&
      cardState.data.data?.find((x) => x.id === id)
    );
  };
  const cardState = useSelector((state: ApplicationState) => state.card);

  const card = getById(cardState, id) as Data;
  let { attributes: at } = card || {};

  let cardInfo: Item[] = [];
  let cardBins: ItemsDetail = {
    sectionName: "",
    itemsData: [],
  };
  if (at) {
    cardInfo = [
      {
        fieldName: "CARD PREFIX NAME",
        fieldValue: at.Name,
      },
    ];
    cardBins = {
      sectionName: "Card Bin",
      itemsData: at.CardBin?.map((cardBin) => {
        return {
          sectionName: "Card Bin Info",
          itemData: [
            { fieldName: "DESC LONG", fieldValue: cardBin.DescLong },
            { fieldName: "Desc Short", fieldValue: cardBin.DescShort },
            { fieldName: "DUKPT", fieldValue: cardBin.DUKPT },
            {
              fieldName: "Tipping Enabled",
              fieldValue: cardBin.TippingEnabled,
            },
            { fieldName: "PIN Block", fieldValue: cardBin.PINBlock },
          ],
          bin: cardBin.Bin,
        };
      }),
    };
  }

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Card Prefix" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Box style={{ position: "relative" }}>
                  <ItemDetailViewSection
                    sectionName="Card Prefix Info"
                    itemData={cardInfo}
                  />

                  <ItemsDetailViewSection
                    sectionName={cardBins.sectionName}
                    itemsData={cardBins.itemsData}
                    lastItem
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default CardView;
